// 应用模块
const state = {
  loading: false,
  error: null,
  deviceType: 'primary'
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_DEVICE_TYPE(state, deviceType) {
    state.deviceType = deviceType
  }
}

const actions = {
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
  setError({ commit }, error) {
    commit('SET_ERROR', error)
  },
  setDeviceType({ commit }, deviceType) {
    commit('SET_DEVICE_TYPE', deviceType)
  }
}

const getters = {
  loading: state => state.loading,
  error: state => state.error,
  deviceType: state => state.deviceType,
  isMobile: state => state.deviceType === 'mobile',
  isPrimaryDevice: state => state.deviceType === 'primary'
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

